import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useData } from "../../firebase/context";
import { getColection } from "../../firebase/fireStore";
import { Button, Typography, Col, Row, Card } from "antd";
import test from "../../assets/images/test.png";
import { useHistory } from "react-router-dom";
import Cargando from "../../components/Cargando";
import { format } from "date-fns";
import { timeToString } from "../../utils/timeToString";
import { es } from "date-fns/locale";
const Test = () => {
  let history = useHistory();
  const { Text } = Typography;
  const { usuario } = useData();
  const [loading, setLoading] = useState(true);
  const [data, seData] = useState([]);
  console.log(data);
  const getDataTest = async () => {
    setLoading(true);
    const response = (await getColection("test")) || [];
    const getdata = response.filter(
      (item) => item.data.email === usuario.email
    );
    seData(getdata);

    setLoading(false);
    //setTopic(getdata.data.topic);
  };

  useEffect(() => {
    data.length <= 0 && getDataTest();
  }, []);

  return (
    <div>
      {loading && Cargando}
      <Row gutter={16}>
        {data.length > 0 ? (
          data.map((res, index) => (
            <Card
              key={index}
              style={{
                width: 300,
                height: 150,
                marginTop: 16,
                marginLeft: 16,
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontWeight: "bold" }}>Nivel de ansiedad:</div>
                <Text
                  type={
                    res.data.level === "leve"
                      ? "success"
                      : res.data.level === "alta"
                      ? "danger"
                      : res.data.level === "moderada"
                      ? "warning"
                      : "secondary"
                  }
                  style={{ fontWeight: "bold" }}
                >
                  {res.data.level && res.data.level}
                </Text>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ fontWeight: "bold" }}>Fecha de resultado:</div>
                <div>
                  {res.data.time &&
                    format(
                      new Date(timeToString(res.data.time.toDate())),
                      "PPP",
                      {
                        locale: es,
                      }
                    )}
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <Button
                  onClick={() => {
                    history.push("/resultados", {
                      res,
                    });
                  }}
                >
                  Ver más
                </Button>
              </div>
            </Card>
          ))
        ) : (
          <div style={{ diplay: "flex", flexDirection: "column" }}>
            <Row>
              <Col span={24}>
                <Text>
                  🤓 Si realizaste el test, nuestros profesionales están
                  generando tus resultados.
                </Text>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Text>
                  ✅ Si aún no lo has hecho te invitamos a realizarlo aquí{" "}
                </Text>{" "}
                <Button
                  onClick={() =>
                    window.open("https://tally.so/r/me58Nk", "_blank")
                  }
                >
                  Test de ansiedad
                </Button>
              </Col>
            </Row>

            <img width={400} src={test} />
          </div>
        )}
      </Row>
    </div>
  );
};

export default Test;
